module.exports = __webpack_public_path__ + "static/img/15063B_1_R_20200812_LC.33a3588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15063B_1_R_20200812_LC.png
// module id = EVMs
// module chunks = 0